"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
function getDefaultBrowserTimeZone() {
    const timeZone = luxon_1.DateTime.local().zoneName;
    /**
     * If we are unable to determine the timezone
     * we fallback to UTC
     */
    if (timeZone === "Etc/Unknown") {
        return "UTC";
    }
    return timeZone;
}
exports.default = getDefaultBrowserTimeZone;
